import React, { useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator,
  Pressable
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { useTranslation } from 'react-i18next'
import Card from '../../shared/card/Card'
import CardSeparator from '../../shared/card/CardSeparator'
import Select from '../../shared/form/Select'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { useLabourStore } from '../../../stores/labour'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectKey, mapSelectValue, validateDOBFormat, validateDOBYear, validateDate } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import MaskInput, { Masks } from 'react-native-mask-input'
import moment from 'moment'
import CalenderPicker from 'react-native-calendar-picker'
import Toast from 'react-native-toast-message'

type response = {
    success: boolean
    message: string
    error: string
}

const intialValues = {
    previousemployee: "",
    employmentstartdate: "",
    startingwage: "",
    jobtitle: "",
    qualified4arecepient: null,
    pbenefitsrecipient: "",
    pbenefitsstate: "",
    isveteranofarmed: null,
    vpbenefitsrecipient: "",
    vpbenefitsstate: "",
    isexfeleon: "",
    felonyconvictionstartdate: "",
    typeofconviction: "",
    releasedate: "",
    felonstate: "",
    isworkreleaseprogram: "",
    communityresidence: "",
    vocationalrehabiltaion: "",
    youthemployee: "",
    qualifiedsnap: "",
    snaprecepient: "",
    snapstate: "",
    ssiincome: "",
    islongtermrecepient: null,
    tanfrecepient: "",
    tanfstate: "",
    isltur: null,
    lturstate: "",
}

const WotcInformationForm = ({ navigation, route }): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        essUserOnBoardingFormKey,
        mode
    } = params
    const { t } = useTranslation()
    const { loading, postwotconline } = useFormsStore()
    const { initializeData } = useInitializeStore()
    const { labourData } = useLabourStore()
    const { personalData } = usePersonalStore()
    const [visibledate, setVisibleDate] = useState(false)
    const [visibledate1, setVisibleDate1] = useState(false)
    const [visibledate2, setVisibleDate2] = useState(false)



    const w4schema = yup.object().shape({
        previousemployee: yup.string().required("Have you worked for this employer before is a required field"),

        employmentstartdate: yup.string().when("previousemployee", (previousemployee: any, schema) => {
            if (previousemployee == 1) {
                return schema
                    .required("Employment Start  Date is a required field")
                    .test('is-date-format', "It should match the format MM/DD/YYYY", validateDOBFormat)
                    .test('is-date-valid', "Invalid date, something wrong in the day", validateDate);
            }
            return schema.nullable();
        }),
        isexfeleon: yup.string().required("Are you an Ex-felon is a required field"),
        felonyconvictionstartdate: yup.string().when("isexfeleon", (isexfeleon: any, schema) => {
            if (isexfeleon == 1) {
                return schema
                    .required("Felony Conviction Start Date is a required field")
                    .test('is-date-format', "It should match the format MM/DD/YYYY", validateDOBFormat)
                    .test('is-date-valid', "Invalid date, something wrong in the day", validateDate);
            }
            return schema.nullable();
        }),
        releasedate: yup.string().when("isexfeleon", (isexfeleon: any, schema) => {
            if (isexfeleon == 1) {
                return schema
                    .required("Release Date is a required field")
                    .test('is-date-format', "It should match the format MM/DD/YYYY", validateDOBFormat)
                    .test('is-date-valid', "Invalid date, something wrong in the day", validateDate);
            }
            return schema.nullable();
        }),
        startingwage: yup.number().when("previousemployee", (previousemployee: any, schema) => {
            if (previousemployee == 1) {
                return schema
                    .required("Starting Wage is a required field")
                    .typeError('Please enter numeric values')
            }
            return schema.nullable();
        }),
        jobtitle: yup.string().when("previousemployee", (previousemployee: any, schema) => {
            if (previousemployee == 1) {
                return schema
                    .required('Job Title is a required field')
                    .typeError('Please enter numeric values')
            }
            return schema.nullable();
        }),
        qualified4arecepient: yup
            .string()
            .required('Qualified IV-A Recipient is a required field'),
        pbenefitsrecipient: yup.string().when("qualified4arecepient", (qualified4arecepient: any, schema) => {
            if (qualified4arecepient == 1) {
                return schema.required("Benefits Recipient is a required field")
            }
            return schema.nullable();
        }),
        pbenefitsstate: yup.string().when("qualified4arecepient", (qualified4arecepient: any, schema) => {
            if (qualified4arecepient == 1) {
                return schema.required("City and State of benefits is a required field")
            }
            return schema.nullable();
        }),
        isveteranofarmed: yup.string().required("Are you a veteran is a required field"),
        vpbenefitsrecipient: yup.string().when("isveteranofarmed", (isveteranofarmed: any, schema) => {
            if (isveteranofarmed == 1) {
                return schema.required("Benefits Recipient is a required field")
            }
            return schema.nullable();
        }),
        vpbenefitsstate: yup.string().when("isveteranofarmed", (isveteranofarmed: any, schema) => {
            if (isveteranofarmed == 1) {
                return schema.required("City and State of benefits is a required field")
            }
            return schema.nullable();
        }),
        felonstate: yup.string(),
        typeofconviction: yup.string(),
        isworkreleaseprogram: yup.string().required("Are you in work release program is a required field"),
        communityresidence: yup.string().nullable(),
        vocationalrehabiltaion: yup.string().nullable(),
        youthemployee: yup.string().nullable(),
        qualifiedsnap: yup.string().nullable(),
        snaprecepient: yup.string().when("qualifiedsnap", (qualifiedsnap: any, schema) => {
            if (qualifiedsnap == 1) {
                return schema.required("Benefits Recipient is a required field")
            }
            return schema.nullable();
        }),
        snapstate: yup.string().when("qualifiedsnap", (qualifiedsnap: any, schema) => {
            if (qualifiedsnap == 1) {
                return schema.required("City and State of benefits is a required field")
            }
            return schema.nullable();
        }),
        ssiincome: yup.string().nullable(),
        islongtermrecepient: yup.string().nullable(),
        tanfrecepient: yup.string().when("qualifiedsnap", (islongtermrecepient: any, schema) => {
            if (islongtermrecepient == 1) {
                return schema.required("Benefits Recipient is a required field")
            }
            return schema.nullable();
        }),
        tanfstate: yup.string().when("qualifiedsnap", (islongtermrecepient: any, schema) => {
            if (islongtermrecepient == 1) {
                return schema.required("City and State of benefits is a required field")
            }
            return schema.nullable();
        }),

        isltur: yup.string().nullable(),
        lturstate: yup.string().when("isltur", (isltur: any, schema) => {
            if (isltur == 1) {
                return schema.required("City and State of benefits is a required field")
            }
            return schema.nullable();
        }),
    });
    const options4 = [
        { key: 1, value: "Federal conviction" },
        { key: 2, value: "State conviction" }
    ]
    const options1 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]
    const options2 = [
        { key: 1, value: 'Rural Renewal Country (RRC)' },
        { key: 2, value: 'Empowerment Zone (EZ)' }
    ]

    function getvalue(value) {
        switch (value) {
            case 0:
                return false;

            case 1:
                return true;
            default:
                return null;
        }
    }
    function getnumber(value) {
        switch (value) {
            case 0:
                return 0;

            case 1:
                return 1;
            default:
                return null;
        }
    }


    const handlesubmit = async (values) => {
        let youthemployee = getvalue(values?.youthemployee)
        let qualifiedSnap = getvalue(values?.qualifiedsnap)
        let ssiincome = getvalue(values?.ssiincome)
        let qualifiedIvarecipient = getvalue(values?.qualified4arecepient)
        let isveteranofarmed = getvalue(values?.isveteranofarmed)
        let isexfeleon = getvalue(values?.isexfeleon)
        let isworkreleaseprogram = getvalue(values?.isworkreleaseprogram)
        let vocationalrehabiltaion = getvalue(values?.vocationalrehabiltaion)
        let islongtermrecepient = getvalue(values?.islongtermrecepient)
        let isltur = getvalue(values?.isltur)
        let typeofconviction = getnumber(values?.typeofconviction)
        let communityresidence = getnumber(values?.communityresidence)
        let startingwage = values?.startingwage ? values?.startingwage : null
        const data = {
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: userId,
            completeOnline: mode === 'upload' ? false : true,
            essUserKey: initializeData?.userkey,
            entityId: personalData?.entityId,
            previousEmployee: values?.previousemployee == 0 ? false : true,
            employmentStartDate: values?.employmentstartdate ? moment(values.employmentstartdate).format("YYYY-MM-DD") : null,
            startingWage: startingwage,
            jobDesc: values?.jobtitle,
            qualifiedIvarecipient: qualifiedIvarecipient,
            pbenifitsRecipient: values?.pbenefitsrecipient,
            pbenifitsState: values?.pbenefitsstate,
            veteranOfArmed: isveteranofarmed,
            vpbenifitsRecipient: values?.vpbenefitsrecipient,
            vpbenifitsState: values?.vpbenefitsstate,
            exFelon: isexfeleon,
            felonyConvictionStartDate: values?.felonyconvictionstartdate ? moment(values.felonyconvictionstartdate).format("YYYY-MM-DD") : null,
            typeOfConviction: typeofconviction,
            releaseDate: values?.releasedate ? moment(values.releasedate).format("YYYY-MM-DD") : null,
            felonState: values.felonstate,
            workReleaseProgram: isworkreleaseprogram,
            communityResidence: communityresidence,
            vocationalRehabilation: vocationalrehabiltaion,
            youthEmployee: youthemployee,
            qualifiedSnap: qualifiedSnap,
            snapRecepient: values?.snaprecepient,
            snapState: values?.snapstate,
            ssincome: ssiincome,
            isLongtermRecepient: islongtermrecepient,
            tanfrecepient: values?.tanfrecepient,
            tanfstate: values?.tanfstate,
            isLturecepient: isltur,
            lturstate: values?.lturstate
        }
        const response: any = await postwotconline(data)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'WOTC Information'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={w4schema}
                    onSubmit={async (values, actions,) => {
                        if (mode == "upload") {
                            handlesubmit(values)
                        }
                        else {
                            navigation.navigate('Wotconline', {
                                essUserOnBoardingKey: userId,
                                essUserOnBoardingFormKey,
                                values,
                                completeOnline: mode === 'upload' ? false : true
                            })
                        }
                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: "50%" }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Have you worked for this employer before? *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Have you worked for this employer before ?"
                                                options={options1}
                                                selectedOption={mapSelectValue(
                                                    options1,
                                                    props.values.previousemployee
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue('previousemployee', option - 1)
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.previousemployee &&
                                                props.errors.previousemployee && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.previousemployee}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    {Number(props.values.previousemployee) == 1 && <>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Employment Start Date * '}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                {/* <MaskInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.employmentstartdate || ''}
                                                onChangeText={(text) => {
                                                    props.handleChange('employmentstartdate')(text);
                                                }}
                                                onBlur={props.handleBlur('employmentstartdate')}
                                                mask={Masks.DATE_MMDDYYYY}
                                                keyboardType="numeric"
                                                placeholder="mm/dd/yyyy"

                                            /> */}
                                                <Pressable onPress={() => setVisibleDate1(!visibledate1)}>
                                                    <MaskInput
                                                        style={[
                                                            globalStyles.input,
                                                            globalStyles.inputLight,
                                                        ]}
                                                        value={props.values.employmentstartdate || ''}
                                                        // onChangeText={props.handleChange('dateOfBirth')}
                                                        onChangeText={(text) => {
                                                            props.handleChange('employmentstartdate')(text);
                                                        }}
                                                        onBlur={props.handleBlur('employmentstartdate')}
                                                        mask={Masks.DATE_MMDDYYYY}
                                                        keyboardType="numeric"
                                                        placeholder="mm/dd/yyyy"
                                                    />
                                                </Pressable>
                                                {/* {props.touched.employmentstartdate && props.errors.employmentstartdate && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.employmentstartdate}
                                                    </Text>
                                                )} */}
                                            </View>
                                        </View>

                                        {visibledate1 &&
                                            <CalenderPicker
                                                width={400}
                                                initialDate={
                                                    props.values.employmentstartdate &&
                                                        new Date(props.values.employmentstartdate) instanceof Date &&
                                                        !isNaN(new Date(props.values.employmentstartdate))
                                                        ? new Date(props.values.employmentstartdate)
                                                        : new Date()
                                                }
                                                onDateChange={(day) => {

                                                    const selectedDate = moment(day).format('MM/DD/YYYY')
                                                    setVisibleDate1(!visibledate1)
                                                    props.setFieldValue('employmentstartdate', selectedDate)
                                                }}
                                            />

                                        }
                                        {props.touched.employmentstartdate && props.errors.employmentstartdate && (
                                            <Text style={[globalStyles.dangerAlert, { textAlign: "right" }]}>
                                                {props.errors.employmentstartdate}
                                            </Text>
                                        )}


                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2, {
                                                    marginTop: 5
                                                }
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Starting Wage * '}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.startingwage}
                                                    keyboardType="numeric"
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('startingwage')(text)
                                                        }
                                                    }}
                                                />
                                                {props.touched.startingwage && props.errors.startingwage && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.startingwage}
                                                    </Text>
                                                )}
                                            </View>
                                        </View>

                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Job Position (Title) or SOC(Standard Occupation Classification) *'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.jobtitle}
                                                    onChangeText={(text) => {

                                                        props.handleChange('jobtitle')(text)

                                                    }}
                                                />
                                                {props.touched.jobtitle && props.errors.jobtitle && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.jobtitle}
                                                    </Text>
                                                )}
                                            </View>
                                        </View>
                                    </>
                                    }
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: "50%" }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Are you a Qualified IV-A Recipient *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Are you a Qualified IV-A Recipient"
                                                options={options1}
                                                selectedOption={mapSelectValue(
                                                    options1,
                                                    props.values.qualified4arecepient
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue(
                                                        'qualified4arecepient',
                                                        option - 1
                                                    )
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.qualified4arecepient &&
                                                props.errors.qualified4arecepient && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.qualified4arecepient as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    {props.values.qualified4arecepient == 1 &&
                                        <>
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Enter the name of the primary benefits recipient *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <TextInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.pbenefitsrecipient}
                                                        onChangeText={(text) => {
                                                            props.handleChange('pbenefitsrecipient')(text)
                                                        }}
                                                    />
                                                    {props.touched.pbenefitsrecipient && props.errors.pbenefitsrecipient && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.pbenefitsrecipient}
                                                        </Text>
                                                    )}
                                                </View>
                                            </View>
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Enter the city and state(s) where benefits were received *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <TextInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.pbenefitsstate}
                                                        onChangeText={(text) => {
                                                            props.handleChange('pbenefitsstate')(text)
                                                        }}
                                                    />
                                                    {props.touched.pbenefitsstate && props.errors.pbenefitsstate && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.pbenefitsstate}
                                                        </Text>
                                                    )}
                                                </View>
                                            </View>
                                        </>
                                    }
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: "50%" }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Are you a veteran of the U.S. Armed Forces *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Are you a veteran of the U.S. Armed Forces"
                                                options={options1}
                                                selectedOption={mapSelectValue(
                                                    options1,
                                                    props.values.isveteranofarmed
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue(
                                                        'isveteranofarmed',
                                                        option - 1
                                                    )
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.isveteranofarmed &&
                                                props.errors.isveteranofarmed && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.isveteranofarmed as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    {props.values.isveteranofarmed == 1 &&
                                        <>
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Enter the name of the primary benefits recipient *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <TextInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.vpbenefitsrecipient}
                                                        onChangeText={(text) => {
                                                            props.handleChange('vpbenefitsrecipient')(text)
                                                        }}
                                                    />
                                                    {props.touched.vpbenefitsrecipient && props.errors.vpbenefitsrecipient && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.vpbenefitsrecipient}
                                                        </Text>
                                                    )}
                                                </View>
                                            </View>
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Enter the city and state(s) where benefits were received *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <TextInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.vpbenefitsstate}
                                                        onChangeText={(text) => {
                                                            props.handleChange('vpbenefitsstate')(text)
                                                        }}
                                                    />
                                                    {props.touched.vpbenefitsstate && props.errors.vpbenefitsstate && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.vpbenefitsstate}
                                                        </Text>
                                                    )}
                                                </View>
                                            </View>
                                        </>
                                    }
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: "50%" }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Are you an Ex-Felon *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Are you an Ex-Felon"
                                                options={options1}
                                                selectedOption={mapSelectValue(
                                                    options1,
                                                    props.values.isveteranofarmed
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue(
                                                        'isexfeleon',
                                                        option - 1
                                                    )
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.isexfeleon &&
                                                props.errors.isexfeleon && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.isexfeleon}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    {Number(props.values.isexfeleon) == 1 &&
                                        <>
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Enter date of felony conviction *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    {/* <MaskInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.felonyconvictionstartdate || ''}
                                                        onChangeText={(text) => {
                                                            props.handleChange('felonyconvictionstartdate')(text);
                                                        }}
                                                        onBlur={props.handleBlur('felonyconvictionstartdate')}
                                                        mask={Masks.DATE_MMDDYYYY}
                                                        keyboardType="numeric"
                                                        placeholder="mm/dd/yyyy"

                                                    /> */}
                                                    <Pressable onPress={() => setVisibleDate(!visibledate)}>
                                                        <MaskInput
                                                            style={[
                                                                globalStyles.input,
                                                                globalStyles.inputLight,
                                                            ]}
                                                            value={props.values.felonyconvictionstartdate || ''}
                                                            // onChangeText={props.handleChange('dateOfBirth')}
                                                            onChangeText={(text) => {
                                                                props.handleChange('felonyconvictionstartdate')(text);
                                                            }}
                                                            onBlur={props.handleBlur('felonyconvictionstartdate')}
                                                            mask={Masks.DATE_MMDDYYYY}
                                                            keyboardType="numeric"
                                                            placeholder="mm/dd/yyyy"
                                                        />
                                                    </Pressable>


                                                </View>
                                            </View>
                                            {visibledate && (
                                                <CalenderPicker
                                                    width={400}
                                                    initialDate={
                                                        props.values.felonyconvictionstartdate &&
                                                            new Date(props.values.felonyconvictionstartdate) instanceof Date &&
                                                            !isNaN(new Date(props.values.felonyconvictionstartdate))
                                                            ? new Date(props.values.felonyconvictionstartdate)
                                                            : new Date()
                                                    }
                                                    onDateChange={(day) => {
                                                        const selectedDate = moment(day).format('MM/DD/YYYY')
                                                        setVisibleDate(!visibledate)
                                                        props.setFieldValue('felonyconvictionstartdate', selectedDate)
                                                    }}
                                                />
                                            )
                                            }
                                            {props.touched.felonyconvictionstartdate && props.errors.felonyconvictionstartdate && (
                                                <Text style={[globalStyles.dangerAlert, { textAlign: "right" }]}>
                                                    {props.errors.felonyconvictionstartdate}
                                                </Text>
                                            )}
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Enter release date *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    {/* <MaskInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.releasedate || ''}
                                                        onChangeText={(text) => {
                                                            props.handleChange('releasedate')(text);
                                                        }}
                                                        onBlur={props.handleBlur('releasedate')}
                                                        mask={Masks.DATE_MMDDYYYY}
                                                        keyboardType="numeric"
                                                        placeholder="mm/dd/yyyy"

                                                    /> */}
                                                    <Pressable onPress={() => setVisibleDate2(!visibledate2)}>
                                                        <MaskInput
                                                            style={[
                                                                globalStyles.input,
                                                                globalStyles.inputLight,
                                                            ]}
                                                            value={props.values.releasedate || ''}
                                                            // onChangeText={props.handleChange('dateOfBirth')}
                                                            onChangeText={(text) => {
                                                                props.handleChange('releasedate')(text);
                                                            }}
                                                            onBlur={props.handleBlur('releasedate')}
                                                            mask={Masks.DATE_MMDDYYYY}
                                                            keyboardType="numeric"
                                                            placeholder="mm/dd/yyyy"
                                                        />
                                                    </Pressable>

                                                </View>
                                            </View>
                                            {visibledate2 && (
                                                <CalenderPicker
                                                    width={400}
                                                    initialDate={
                                                        props.values.releasedate &&
                                                            new Date(props.values.releasedate) instanceof Date &&
                                                            !isNaN(new Date(props.values.releasedate))
                                                            ? new Date(props.values.releasedate)
                                                            : new Date()
                                                    }
                                                    onDateChange={(day) => {
                                                        const selectedDate = moment(day).format('MM/DD/YYYY')
                                                        setVisibleDate2(!visibledate2)
                                                        props.setFieldValue('releasedate', selectedDate)
                                                    }}
                                                />
                                            )
                                            }
                                            {props.touched.releasedate && props.errors.releasedate && (
                                                <Text style={[globalStyles.dangerAlert, { textAlign: "right" }]}>
                                                    {props.errors.releasedate}
                                                </Text>
                                            )}

                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Type of conviction *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <SelectKeyValue
                                                        title="select Type of conviction"
                                                        options={options4}
                                                        selectedOption={mapSelectValue(
                                                            options4,
                                                            props.values.typeofconviction
                                                        )}
                                                        onSelect={(option: any) => {
                                                            props.setFieldValue(
                                                                'typeofconviction',
                                                                option - 1
                                                            )
                                                        }}
                                                        textColor="primary"
                                                    />
                                                    {props.touched.typeofconviction &&
                                                        props.errors.typeofconviction && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.typeofconviction}
                                                            </Text>
                                                        )}
                                                </View>
                                            </View>

                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: "50%" }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'List applicable state *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <TextInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.felonstate}
                                                        onChangeText={(text) => {
                                                            props.handleChange('felonstate')(text)
                                                        }}
                                                    />
                                                    {props.touched.felonstate && props.errors.felonstate && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.felonstate}
                                                        </Text>
                                                    )}
                                                </View>
                                            </View>
                                        </>
                                    }
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: "50%" }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Are you in a Work Release Program *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Are you in a Work Release Program"
                                                options={options1}
                                                selectedOption={mapSelectValue(
                                                    options1,
                                                    props.values.isworkreleaseprogram
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue(
                                                        'isworkreleaseprogram',
                                                        option - 1
                                                    )
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.isworkreleaseprogram &&
                                                props.errors.isworkreleaseprogram && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.isworkreleaseprogram}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    {Number(props.values.isworkreleaseprogram) == 1 && <>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Designated Community Resident (DCR)'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Designated Community Resident (DCR)"
                                                    options={options2}
                                                    selectedOption={mapSelectValue(
                                                        options2,
                                                        props.values.communityresidence
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'communityresidence',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />
                                                {props.touched.communityresidence &&
                                                    props.errors.communityresidence && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.communityresidence}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Are you a Vocational Rehabilitation (VR) Referral'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Vocational Rehabilitation (VR) Referral"
                                                    options={options1}
                                                    selectedOption={mapSelectValue(
                                                        options1,
                                                        props.values.vocationalrehabiltaion
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'vocationalrehabiltaion',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />
                                                {props.touched.vocationalrehabiltaion &&
                                                    props.errors.vocationalrehabiltaion && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.vocationalrehabiltaion}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Are you a Qualified Summer Youth Employee'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Qualified Summer Youth Employee"
                                                    options={options1}
                                                    selectedOption={mapSelectValue(
                                                        options1,
                                                        props.values.youthemployee
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'youthemployee',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />
                                                {props.touched.youthemployee &&
                                                    props.errors.youthemployee && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.youthemployee}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Are you a  Qualified SNAP (Food Stamps) Recipient'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Are you a  Qualified SNAP (Food Stamps) Recipient"
                                                    options={options1}
                                                    selectedOption={mapSelectValue(
                                                        options1,
                                                        props.values.qualifiedsnap
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'qualifiedsnap',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />

                                                {props.touched.qualifiedsnap &&
                                                    props.errors.qualifiedsnap && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.qualifiedsnap}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        {Number(props.values.qualifiedsnap) == 1 &&
                                            <>
                                                <View
                                                    style={[
                                                        globalStyles.hDirection,
                                                        globalStyles.hBetweenItems,
                                                        globalStyles.mb2
                                                    ]}
                                                >
                                                    <View style={{ justifyContent: 'center', width: "50%" }}>
                                                        <Text
                                                            style={[
                                                                globalStyles.inputLabel,
                                                                globalStyles.inputLabelLarge,
                                                                globalStyles.inputLabelPrimary
                                                            ]}
                                                        >
                                                            {'Enter the name of the primary benefits recipient *'}
                                                        </Text>
                                                    </View>


                                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                                        <TextInput
                                                            style={[globalStyles.input, globalStyles.inputLight]}
                                                            value={props.values.snaprecepient}
                                                            onChangeText={(text) => {
                                                                props.handleChange('snaprecepient')(text)
                                                            }}
                                                        />
                                                        {props.touched.snaprecepient && props.errors.snaprecepient && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.snaprecepient}
                                                            </Text>
                                                        )}
                                                    </View>
                                                </View>
                                                <View
                                                    style={[
                                                        globalStyles.hDirection,
                                                        globalStyles.hBetweenItems,
                                                        globalStyles.mb2
                                                    ]}
                                                >
                                                    <View style={{ justifyContent: 'center', width: "50%" }}>
                                                        <Text
                                                            style={[
                                                                globalStyles.inputLabel,
                                                                globalStyles.inputLabelLarge,
                                                                globalStyles.inputLabelPrimary
                                                            ]}
                                                        >
                                                            {'Enter the city and state(s) where benefits were received *'}
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                                        <TextInput
                                                            style={[globalStyles.input, globalStyles.inputLight]}
                                                            value={props.values.snapstate}
                                                            onChangeText={(text) => {
                                                                props.handleChange('snapstate')(text)
                                                            }}
                                                        />
                                                        {props.touched.snapstate && props.errors.snapstate && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.snapstate}
                                                            </Text>
                                                        )}
                                                    </View>
                                                </View>
                                            </>
                                        }
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Are you receving Supplemental Security Income'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Are you receving Supplemental Security Income"
                                                    options={options1}
                                                    selectedOption={mapSelectValue(
                                                        options1,
                                                        props.values.ssiincome
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'ssiincome',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />
                                                {props.touched.ssiincome &&
                                                    props.errors.ssiincome && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.ssiincome}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Are you a Long-term Family Assistance (long-term TANF) recipient'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Are you a Long-term Family Assistance (long-term TANF) recipient"
                                                    options={options1}
                                                    selectedOption={mapSelectValue(
                                                        options1,
                                                        props.values.islongtermrecepient
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'islongtermrecepient',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />
                                                {props.touched.islongtermrecepient &&
                                                    props.errors.islongtermrecepient && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.islongtermrecepient as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        {props.values.islongtermrecepient == 1 &&
                                            <>
                                                <View
                                                    style={[
                                                        globalStyles.hDirection,
                                                        globalStyles.hBetweenItems,
                                                        globalStyles.mb2
                                                    ]}
                                                >
                                                    <View style={{ justifyContent: 'center', width: "50%" }}>
                                                        <Text
                                                            style={[
                                                                globalStyles.inputLabel,
                                                                globalStyles.inputLabelLarge,
                                                                globalStyles.inputLabelPrimary
                                                            ]}
                                                        >
                                                            {'Enter the name of the primary benefits recipient *'}
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                                        <TextInput
                                                            style={[globalStyles.input, globalStyles.inputLight]}
                                                            value={props.values.tanfrecepient}
                                                            onChangeText={(text) => {
                                                                props.handleChange('tanfrecepient')(text)
                                                            }}
                                                        />
                                                        {props.touched.tanfrecepient && props.errors.tanfrecepient && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.tanfrecepient}
                                                            </Text>
                                                        )}
                                                    </View>
                                                </View>
                                                <View
                                                    style={[
                                                        globalStyles.hDirection,
                                                        globalStyles.hBetweenItems,
                                                        globalStyles.mb2
                                                    ]}
                                                >
                                                    <View style={{ justifyContent: 'center', width: "50%" }}>
                                                        <Text
                                                            style={[
                                                                globalStyles.inputLabel,
                                                                globalStyles.inputLabelLarge,
                                                                globalStyles.inputLabelPrimary
                                                            ]}
                                                        >
                                                            {'Enter the city and state(s) where benefits were received *'}
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                                        <TextInput
                                                            style={[globalStyles.input, globalStyles.inputLight]}
                                                            value={props.values.tanfstate}
                                                            onChangeText={(text) => {
                                                                props.handleChange('tanfstate')(text)
                                                            }}
                                                        />
                                                        {props.touched.tanfstate && props.errors.tanfstate && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.tanfstate}
                                                            </Text>
                                                        )}
                                                    </View>
                                                </View>
                                            </>
                                        }

                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: "50%" }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Are you a qualified long-term unemployment recipient (LTUR)'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <SelectKeyValue
                                                    title="Are you a qualified long-term unemployment recipient (LTUR)"
                                                    options={options1}
                                                    selectedOption={mapSelectValue(
                                                        options1,
                                                        props.values.isltur
                                                    )}
                                                    onSelect={(option: any) => {
                                                        props.setFieldValue(
                                                            'isltur',
                                                            option - 1
                                                        )
                                                    }}
                                                    textColor="primary"
                                                />
                                                {props.touched.isltur &&
                                                    props.errors.isltur && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.isltur as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        {props.values.isltur == 1 &&
                                            <>
                                                <View
                                                    style={[
                                                        globalStyles.hDirection,
                                                        globalStyles.hBetweenItems,
                                                        globalStyles.mb2
                                                    ]}
                                                >
                                                    <View style={{ justifyContent: 'center', width: "50%" }}>
                                                        <Text
                                                            style={[
                                                                globalStyles.inputLabel,
                                                                globalStyles.inputLabelLarge,
                                                                globalStyles.inputLabelPrimary
                                                            ]}
                                                        >
                                                            {'Enter the city and state(s) where benefits were received *'}
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                                        <TextInput
                                                            style={[globalStyles.input, globalStyles.inputLight]}
                                                            value={props.values.lturstate}
                                                            onChangeText={(text) => {
                                                                props.handleChange('lturstate')(text)
                                                            }}
                                                        />
                                                        {props.touched.lturstate && props.errors.lturstate && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.lturstate}
                                                            </Text>
                                                        )}
                                                    </View>
                                                </View>
                                            </>
                                        }
                                    </>}
                                </View>
                            </Card>
                            {loading ? (
                                <ActivityIndicator />
                            ) : (
                                <View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                            )}
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}
export default WotcInformationForm
